export const ChargebackEventStatusEnum = {
  RESOLVED: 'resolved',
  PENDING: 'pending',
  DECLINED: 'declined',
  DELETED: 'deleted',
  PREVIOUSLY_RESOLVED: 'previously_resolved',
  NOT_FOUND: 'notfound',
  EXPIRED: 'expired',
};

export const ChargebackEventStatus = [
  { title: 'Resolved', value: ChargebackEventStatusEnum.RESOLVED },
  { title: 'Declined', value: ChargebackEventStatusEnum.DECLINED },
  { title: 'Previously Resolved', value: ChargebackEventStatusEnum.PREVIOUSLY_RESOLVED },
  { title: 'Not Found', value: ChargebackEventStatusEnum.NOT_FOUND },
  { title: 'Pending', value: ChargebackEventStatusEnum.PENDING },
  { title: 'Deleted', value: ChargebackEventStatusEnum.DELETED },
  { title: 'Expired', value: ChargebackEventStatusEnum.EXPIRED },
];

export const ChargebackEventOutcomeStatusEnum = {
  RESOLVED: 'resolved',
  PREVIOUSLY_RESOLVED: 'previously_resolved',
  NOT_FOUND: 'notfound',
  DECLINED: 'declined',
};

export const ChargebackEventOutcomeStatus = [
  { title: 'Resolved', value: ChargebackEventOutcomeStatusEnum.RESOLVED },
  { title: 'Previously Resolved', value: ChargebackEventOutcomeStatusEnum.PREVIOUSLY_RESOLVED },
  { title: 'Not Found', value: ChargebackEventOutcomeStatusEnum.NOT_FOUND },
  { title: 'Declined', value: ChargebackEventOutcomeStatusEnum.DECLINED },
];

export const ChargebackEventOutcomeRefundStatusEnum = {
  REFUNDED: 'refunded',
  NOT_REFUNDED: 'not refunded',
  NOT_SETTLED: 'not settled',
};

export const ChargebackEventOutcomeRefundStatus = [
  { title: 'Refunded', value: ChargebackEventOutcomeRefundStatusEnum.REFUNDED },
  { title: 'Not Refunded', value: ChargebackEventOutcomeRefundStatusEnum.NOT_REFUNDED },
  { title: 'Not Settled', value: ChargebackEventOutcomeRefundStatusEnum.NOT_SETTLED },
];
